import { useRef } from 'react';
import PropTypes from 'prop-types';

import chevronGrayIcon from 'assets/chevron-gray.svg';

import styles from 'Pages/TeamDashboard/ProductLibrary/styles.module.scss';

import VersionDropdown from './VersionDropdown';

const FlowSection = ({
  flow,
  sectionRef,
  isVersionDropdownOpen,
  onVersionDropdownToggle,
  onVersionDropdownClose,
  isLibrarySelected,
  onAddVersion,
  onVersionSelect,
  selectedVersion,
  showAddVersion = true,
}) => {
  const versionWrapperRef = useRef(null);

  return (
    <div ref={sectionRef} className={styles.flowSection}>
      <div className={styles.flowSectionHeader}>
        <div className={styles.flowNameGroup}>
          <span className={styles.flowName}>
            {flow.name}
          </span>
          <span className={styles.flowSeparator}>
            ·
          </span>
          <span className={styles.flowScreenCount}>
            {flow.screen_count}
            {' '}
            screens
          </span>
        </div>

        <div className={styles.versionWrapper} ref={versionWrapperRef}>
          <button className={styles.versionButton} onClick={onVersionDropdownToggle}>
            v
            {selectedVersion || flow.current_version}
            <img
              src={chevronGrayIcon}
              alt=""
              className={`${styles.versionChevron} ${isVersionDropdownOpen ? styles.chevronFlipped : ''}`}
            />
          </button>

          {isVersionDropdownOpen && (
            <VersionDropdown
              versions={flow.versions || []}
              currentVersion={selectedVersion || flow.current_version}
              containerRef={versionWrapperRef}
              onClose={onVersionDropdownClose}
              onAddVersion={() => onAddVersion(flow)}
              onVersionSelect={versionNumber => onVersionSelect(flow.uuid, versionNumber)}
              showAddVersion={showAddVersion}
            />
          )}
        </div>
      </div>

      <div className={styles.screensRow}>
        {Array.from({ length: flow.screen_count }, (_, i) => {
          const asset = flow.assets?.[i];
          const assetUrl = asset?.thumbnail_url || asset?.image_url;

          return (
            <div key={i} className={styles.screenItem}>
              <div className={`${styles.screenThumbnail} ${isLibrarySelected ? styles.screenThumbnailSelected : ''}`}>
                {assetUrl
                  ? (
                    <img
                      src={assetUrl}
                      alt={`Screen ${i + 1}`}
                      className={styles.screenImage}
                    />
                  )
                  : (
                    <div className={styles.screenPlaceholder} />
                  )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

FlowSection.propTypes = {
  flow: PropTypes.shape({
    uuid: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    current_version: PropTypes.number.isRequired,
    screen_count: PropTypes.number.isRequired,
    assets: PropTypes.array,
    versions: PropTypes.arrayOf(
      PropTypes.shape({
        version_number: PropTypes.number.isRequired,
        created_at: PropTypes.string.isRequired,
        is_current: PropTypes.bool.isRequired,
      })
    ),
  }).isRequired,
  sectionRef: PropTypes.func.isRequired,
  isVersionDropdownOpen: PropTypes.bool.isRequired,
  onVersionDropdownToggle: PropTypes.func.isRequired,
  onVersionDropdownClose: PropTypes.func.isRequired,
  isLibrarySelected: PropTypes.bool,
  onAddVersion: PropTypes.func.isRequired,
  onVersionSelect: PropTypes.func.isRequired,
  selectedVersion: PropTypes.number,
  showAddVersion: PropTypes.bool,
};

FlowSection.defaultProps = {
  isLibrarySelected: false,
  selectedVersion: null,
  showAddVersion: true,
};

export default FlowSection;
